/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Mode_DarkInputs */

const en_common_mode_dark = /** @type {(inputs: Common_Mode_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const es_common_mode_dark = /** @type {(inputs: Common_Mode_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oscuro`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Common_Mode_DarkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_mode_dark = /** @type {((inputs?: Common_Mode_DarkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Mode_DarkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_mode_dark(inputs)
	return es_common_mode_dark(inputs)
});